import React from 'react';
import './Patterns.css';

export interface RowCardProps {
  /** bootstrap-icons class, e.g. "bi-droplet". Optional — only used when `children` are not provided. */
  icon?: string;
  /** Optional — only used when `children` are not provided. */
  title?: string;
  subtitle?: string;
  /** Click handler for the remove (X) button. If omitted, no button renders. */
  onRemove?: () => void;
  /** aria-label for the remove button (defaults to "Remove"). */
  removeLabel?: string;
  /** Adds .pat-row-card--queued — 4px blue left border. */
  queued?: boolean;
  /** Adds .pat-row-card--late-signoff — 4px red left border. Takes precedence over --queued via cascading CSS. */
  lateSignoff?: boolean;
  /** When provided, renders in place of the icon+title+subtitle body. */
  children?: React.ReactNode;
  /** Override the root data-testid (defaults to 'row-card'). */
  testId?: string;
}

const RowCard: React.FC<RowCardProps> = ({
  icon,
  title,
  subtitle,
  onRemove,
  removeLabel = 'Remove',
  queued,
  lateSignoff,
  children,
  testId,
}) => {
  const classes = [
    'pat-row-card',
    queued ? 'pat-row-card--queued' : '',
    lateSignoff ? 'pat-row-card--late-signoff' : '',
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={classes} data-testid={testId ?? 'row-card'}>
      {children ?? (
        <>
          {icon && (
            <span className="pat-row-card__icon" aria-hidden="true">
              <i className={`bi ${icon}`} data-testid="row-card-icon" />
            </span>
          )}
          <div className="pat-row-card__body">
            {title && <div className="pat-row-card__title">{title}</div>}
            {subtitle && (
              <div className="pat-row-card__subtitle" data-testid="row-card-subtitle">
                {subtitle}
              </div>
            )}
          </div>
          {onRemove && (
            <button
              className="pat-row-card__remove"
              type="button"
              onClick={onRemove}
              aria-label={removeLabel}
            >
              <i className="bi bi-x-lg" aria-hidden="true" />
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default RowCard;
